import * as commissionsService from '../../services/voucher/commissions-service';
import companyService from '../../services/companies-service';
import {
  FETCH_OUTSIDE_BROKER_COMMISSIONS_SUCCESS,
  UPDATE_OUTSIDE_BROKER_COMMISSION_SUCCESS,
  CREATE_OUTSIDE_BROKER_COMMISSION_SUCCESS,
  DELETE_OUTSIDE_BROKER_COMMISSION_SUCCESS,
  UPDATE_OUTSIDE_BROKER_COMMISSION_VENDOR_SUCCESS,
} from './action-types';
import { updateFinancials, updateLoadedFinancials } from './financial-actions';
import { updateDeal } from './deal-actions';

// action creators
const fetchCommissionsSuccess = commissions => ({
  type: FETCH_OUTSIDE_BROKER_COMMISSIONS_SUCCESS,
  payload: commissions,
});

const updateCommissionSuccess = commission => ({
  type: UPDATE_OUTSIDE_BROKER_COMMISSION_SUCCESS,
  payload: commission,
});

const createCommissionSuccess = commission => ({
  type: CREATE_OUTSIDE_BROKER_COMMISSION_SUCCESS,
  payload: commission,
});

const deleteCommissionSuccess = id => ({
  type: DELETE_OUTSIDE_BROKER_COMMISSION_SUCCESS,
  payload: id,
});

const updateCommissionVendorSuccess = (id, vendor) => ({
  type: UPDATE_OUTSIDE_BROKER_COMMISSION_VENDOR_SUCCESS,
  payload: { id, vendor },
});

// async action creators
const fetchCommissions = params => dispatch => commissionsService.fetchCommissions(params)
  .then(commissions => dispatch(fetchCommissionsSuccess(commissions)))
  .catch(console.error);

const updateCommission = (id, data, ignoreFinancialUpdate = false) => dispatch => commissionsService.updateCommission(id, data)
  .then((commission) => {
    dispatch(updateCommissionSuccess(commission));
    if (!ignoreFinancialUpdate && 'gross_commission' in data) {
      dispatch(updateLoadedFinancials(commission.transaction, undefined, 0, {
        force: true,
        skipDealAndTimestampUpdate: true,
      }));
    }
  })
  .catch(console.error);

const createCommission = params => dispatch => companyService.createCompany({
  address: null,
  address2: null,
  city: null,
  country: 'United States',
  name: null,
  postal: null,
  territory: null,
})
  .then(company => commissionsService.createCommission({ vendor: company.id, ...params }))
  .then(commission => dispatch(createCommissionSuccess(commission)))
  .catch(console.error);

const deleteCommission = id => (dispatch, getState) => commissionsService.deleteCommission(id)
  .then(() => {
    const state = getState();
    const dealId = state.deal.deal.id;

    dispatch(updateFinancials(dealId));
    dispatch(deleteCommissionSuccess(id));

    // If the deleted outside broker was the billed party, reset bill-to on the deal
    // so the UI doesn't get stuck showing "Outside Broker" with no valid vendor.
    const deletedCommission = state.outsideBrokerCommissions.commissions.find(c => c.id === id);
    if (
      deletedCommission &&
      state.deal.deal.billed_to_type === 'Outside Broker' &&
      state.deal.deal.billed_party &&
      state.deal.deal.billed_party.id === deletedCommission.vendor_id
    ) {
      dispatch(updateDeal(dealId, { billed_to_type: null, billed_party: null }));
    }
  })
  .catch(console.error);

const updateCommissionVendor = (id, companyId, patch) => dispatch => companyService.patchCompany(companyId, patch)
  .then(res => dispatch(updateCommissionVendorSuccess(id, res)))
  .catch(console.error);


export {
  fetchCommissions,
  updateCommission,
  createCommission,
  deleteCommission,
  updateCommissionVendor,
};
